// Lyaout =============================================================
import { AvailableChildrenType, SugarElementInfo } from "../../Suggester/SugarElementInfo";

export const italic: SugarElementInfo = { name: "italic", availableChildren: { type: AvailableChildrenType.Any } };
